document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-pcx-gallery]').forEach((gallery) => {
    const track = gallery.querySelector('[data-pcx-gallery-track]');
    const thumbs = Array.from(gallery.querySelectorAll('[data-pcx-gallery-thumb]'));
    let index = 0;

    const show = (newIndex) => {
      if (!track || !thumbs.length) return;
      index = (newIndex + thumbs.length) % thumbs.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      thumbs.forEach((thumb) => thumb.classList.remove('is-active'));
      thumbs[index].classList.add('is-active');
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => show(i));
    });
  });

  document.querySelectorAll('[data-pcx-qty-minus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
  });

  document.querySelectorAll('[data-pcx-qty-plus]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });

  document.querySelectorAll('.pcx-v4-card').forEach((root) => {
    const optionsWrap = root.querySelector('[data-pcx-options]');
    if (!optionsWrap) return;

    const useSheetPicker = optionsWrap.dataset.sheetPicker === 'true';
    const variantsJson = root.querySelector('[data-pcx-variants-json]');
    const variantInput = root.querySelector('[data-pcx-variant-id]');
    const optionSelects = Array.from(root.querySelectorAll('[data-pcx-option-index]'));
    const price = root.querySelector('[data-pcx-price]');
    const stock = root.querySelector('[data-pcx-stock]');
    const selectedSize = root.querySelector('[data-pcx-selected-size]');
    const addButton = root.querySelector('.pcx-v4-card__add');

    if (!variantsJson || !variantInput || !optionSelects.length) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsJson.textContent);
    } catch (error) {
      console.error('PCX variants JSON error', error);
      return;
    }

    function formatMoney(cents) {
      return '£' + (Number(cents) / 100).toFixed(2);
    }

    function updateProductState(matchedVariant) {
      if (!matchedVariant) return;

      variantInput.value = matchedVariant.id;

      if (price) {
  const currentPrice = Number(matchedVariant.price || 0);
  const compareAtPrice = Number(matchedVariant.compare_at_price || 0);
  const isOnSale = compareAtPrice > currentPrice;

  price.innerHTML = `
    ${
      isOnSale
        ? `<span class="pcx-v4-card__sale-badge">SALE</span><span class="pcx-v4-card__compare-price">${formatMoney(compareAtPrice)}</span>`
        : ''
    }
    <span class="pcx-v4-card__current-price">
      ${formatMoney(currentPrice)}
    </span>
    <small>inc VAT</small>
  `;
}

      if (selectedSize) {
        const variantText = `${matchedVariant.title} ${matchedVariant.options.join(' ')}`;
        const lengthMatch = variantText.match(/L\s*([0-9]+)/i);
        const widthMatch = variantText.match(/W\s*([0-9]+)/i);

        if (lengthMatch && widthMatch) {
          selectedSize.textContent = `Selected: ${widthMatch[1]} × ${lengthMatch[1]}mm`;
        }
      }

      if (stock) {
        stock.innerHTML = matchedVariant.available ? '✓ In Stock' : 'Sold Out';
      }

      if (addButton) {
        addButton.disabled = !matchedVariant.available;
        const text = addButton.querySelector('span');
        if (text) text.textContent = matchedVariant.available ? 'Add to Cart' : 'Sold Out';
      }
    }

    function updateVariantFromSelects() {
      const selectedOptions = optionSelects.map((select) => select.value);

      const matchedVariant = variants.find((variant) => {
        return selectedOptions.every((value, index) => {
          return String(variant.options[index]) === String(value);
        });
      });

      updateProductState(matchedVariant);
    }

    if (!useSheetPicker) {
      optionSelects.forEach((select) => {
        select.addEventListener('change', updateVariantFromSelects);
      });

      updateVariantFromSelects();
      return;
    }

    const sheetPicker = root.querySelector('[data-pcx-sheet-picker]');
    const widthsWrap = root.querySelector('[data-pcx-widths]');
    const lengthsWrap = root.querySelector('[data-pcx-lengths]');
    const unitButtons = Array.from(root.querySelectorAll('[data-pcx-unit-toggle]'));

    let unitMode = 'mm';

    if (!sheetPicker || !widthsWrap || !lengthsWrap) {
      updateVariantFromSelects();
      return;
    }

    const sizeSelect = optionSelects.find((select) => {
      return Array.from(select.options).some((option) => {
        return /L\s*[0-9]+/i.test(option.value) && /W\s*[0-9]+/i.test(option.value);
      });
    });

    if (!sizeSelect) {
      updateVariantFromSelects();
      return;
    }

    function parseSize(value) {
      const text = String(value);
      const lengthMatch = text.match(/L\s*([0-9]+)/i);
      const widthMatch = text.match(/W\s*([0-9]+)/i);

      if (!lengthMatch || !widthMatch) return null;

      return {
        original: value,
        length: Number(lengthMatch[1]),
        width: Number(widthMatch[1])
      };
    }

    function mmToFeetInches(mm) {
  const totalInches = Math.round(Number(mm) / 25.4);
  const feet = Math.floor(totalInches / 12);
  const inches = totalInches % 12;

  return `${feet} ft ${inches} in`;
}

function formatSizeButton(mm) {
  return unitMode === 'ft'
    ? mmToFeetInches(mm)
    : `${mm}mm`;
}

    const sizes = Array.from(sizeSelect.options)
      .map((option) => parseSize(option.value))
      .filter(Boolean);

    if (!sizes.length) {
      updateVariantFromSelects();
      return;
    }

    const allWidths = [...new Set(sizes.map((size) => size.width))].sort((a, b) => a - b);
    const allLengths = [...new Set(sizes.map((size) => size.length))].sort((a, b) => a - b);

    let selectedWidth = parseSize(sizeSelect.value)?.width || allWidths[0];
    let selectedLength = parseSize(sizeSelect.value)?.length || allLengths[0];

    function combinationExists(width, length) {
      return sizes.some((size) => size.width === width && size.length === length);
    }

    function getSizeValue(width, length) {
      const match = sizes.find((size) => size.width === width && size.length === length);
      return match ? match.original : null;
    }

    function selectVariantBySize(width, length) {
      const sizeValue = getSizeValue(width, length);
      if (!sizeValue) return;

      sizeSelect.value = sizeValue;

      const selectedOptions = optionSelects.map((select) => select.value);

      const matchedVariant = variants.find((variant) => {
        return selectedOptions.every((value, index) => {
          return String(variant.options[index]) === String(value);
        });
      });

      updateProductState(matchedVariant);
    }

    function renderButtons() {
      widthsWrap.innerHTML = '';
      lengthsWrap.innerHTML = '';

      allWidths.forEach((width) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pcx-sheet-picker__button';
        button.textContent = formatSizeButton(width);

        if (width === selectedWidth) button.classList.add('is-active');

        button.addEventListener('click', () => {
          selectedWidth = width;

          if (!combinationExists(selectedWidth, selectedLength)) {
            const firstAvailableLength = allLengths.find((length) => combinationExists(selectedWidth, length));
            if (firstAvailableLength) selectedLength = firstAvailableLength;
          }

          renderButtons();
          selectVariantBySize(selectedWidth, selectedLength);
        });

        widthsWrap.appendChild(button);
      });

      allLengths.forEach((length) => {
        const exists = combinationExists(selectedWidth, length);

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pcx-sheet-picker__button';
        button.textContent = formatSizeButton(length);

        if (length === selectedLength && exists) button.classList.add('is-active');

        if (!exists) {
          button.classList.add('is-disabled');
          button.disabled = true;
        }

        button.addEventListener('click', () => {
          if (!exists) return;

          selectedLength = length;
          renderButtons();
          selectVariantBySize(selectedWidth, selectedLength);
        });

        lengthsWrap.appendChild(button);
      });
    }

    unitButtons.forEach((button) => {
      button.addEventListener('click', () => {
        unitMode = button.dataset.pcxUnitToggle || 'mm';

        unitButtons.forEach((btn) => btn.classList.remove('is-active'));
        button.classList.add('is-active');

        renderButtons();
      });
    });

    optionsWrap.classList.add('pcx-v4-options--sheet-picker');
    sheetPicker.hidden = false;

    renderButtons();
    selectVariantBySize(selectedWidth, selectedLength);
  });
});

// PCX estimated delivery date: 3–6 working days, 12pm cut-off
(function () {
  const deliveryEls = document.querySelectorAll('[data-pcx-delivery-date]');
  if (!deliveryEls.length) return;

  const now = new Date();

  function isWorkingDay(date) {
    const day = date.getDay();
    return day !== 0 && day !== 6;
  }

  function addWorkingDays(startDate, workingDaysToAdd) {
    const date = new Date(startDate);
    let added = 0;

    while (added < workingDaysToAdd) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date)) added++;
    }

    return date;
  }

  function formatDate(date) {
    return date.toLocaleDateString('en-GB', {
      weekday: 'short',
      day: 'numeric',
      month: 'short'
    });
  }

  const startDate = new Date(now);
  if (now.getHours() >= 12 || !isWorkingDay(now)) {
    do {
      startDate.setDate(startDate.getDate() + 1);
    } while (!isWorkingDay(startDate));
  }

  const earliest = addWorkingDays(startDate, 3);
  const latest = addWorkingDays(startDate, 6);

  const text = `${formatDate(earliest)} – ${formatDate(latest)}`;

  deliveryEls.forEach((el) => {
    el.textContent = text;
  });
})();